import React, { useRef, useState } from "react";
import "flowbite";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { useAccount } from "wagmi";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Signinoption from "./Signinoption";
import Verifyregistration from "./Verifyregistration";
import TermsnConditions from "./TermsnConditions";

const Registration = (props) => {
  const { address } = useAccount();
  const { isConnected } = useAccount();
  const [display, setDisplay] = useState("");

  const [newd, setNewd] = useState(false);
  const [registrationform, setRegistrationform] = useState({
    email: "",
    username: "",
  });
  const [phoneno, setPhoneno] = useState();

  const [showSigninModal, setShowSigninModal] = useState(false);
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [checkTerms, setCheckTerms] = useState(false);

  const openTermsModal = () => {
    showTermsModal ? setShowTermsModal(false) : setShowTermsModal(true);
  };

  const checkTermsHandel = () => {
    setCheckTerms(true);
  };
  const openSigninModal = () => {
    showSigninModal ? setShowSigninModal(false) : setShowSigninModal(true);
  };

  const openVerificationModal = () => {
    showVerificationModal
      ? setShowVerificationModal(false)
      : setShowVerificationModal(true);
  };

  const submitUserDetails = async () => {
    try {
      const userData = {
        name: registrationform.username,
        email: registrationform.email,
        walletAddress: address,
        phone: phoneno,
      };
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/register`,
        userData
      );
      if (response.data.success) {
        console.log("Sucessfully registered", response.data);
        // alert("Sucess fully registered",response.data.msg);
        setDisplay(response.data.msg);
        localStorage.setItem("email", registrationform.email);
        localStorage.setItem("phone", phoneno);
        let email = await axios.post(
          `${process.env.REACT_APP_SERVER_URL}/email-otp`,
          { email: registrationform.email }
        );
        let phone = await axios.post(
          `${process.env.REACT_APP_SERVER_URL}/phone-otp`,
          { number: phoneno }
        );
        // console.log(phone)

        toast(
          "Use this OTP email : " +
            email?.data?.OTP +
            " phone : " +
            phone?.data?.otp,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          }
        );
        alert(
          "Use this OTP email : " +
            email?.data?.OTP +
            " phone : " +
            phone?.data?.otp
        );
      } else {
        console.log("error", response.data.msg);

        toast(response.data.msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        alert(response.data.msg);
      }
    } catch (error) {
      console.error("Error logging in:", error);
    }
  };
  return (
    <>
      <div
        className="relative z-50"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-black bg-opacity-20 backdrop-blur transition-opacity"></div>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-2 text-center sm:items-center sm:p-0">
            <div className="relative bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52] rounded-lg shadow dark:bg-gray-700 py-2">
              <div className="bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52] p-2">
                <div className="sm:flex sm:items-start">
                  <div className="px-2">
                    <div className="py-2">
                      <ConnectButton />
                    </div>
                    <h3 className="mb-4 text-xl font-medium text-white dark:text-white">
                      Easy Register & Box Purchase
                    </h3>

                    <div>
                      <label
                        htmlFor="email"
                        className="block mb-2 text-sm text-left font-medium text-white dark:text-white"
                      >
                        Enter Email
                      </label>
                      <input
                        type="email"
                        onChange={(e) =>
                          setRegistrationform({
                            ...registrationform,
                            email: e.target.value,
                          })
                        }
                        className={`{ " border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"${
                          newd ? "bg-gray-50" : "bg-gray-500"
                        }`}
                        placeholder="Email"
                        required
                      />
                    </div>

                    <div>
                      <label className="block mb-2 text-sm text-left font-medium text-white dark:text-white">
                        Enter Phone No
                      </label>
                      <PhoneInput
                        international
                        countryCallingCodeEditable={false}
                        defaultCountry="US"
                        onChange={setPhoneno}
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="password"
                        className="block mb-2 text-sm text-left font-medium text-white dark:text-white"
                      >
                        User Name
                      </label>
                      <input
                        type="text"
                        onChange={(e) =>
                          setRegistrationform({
                            ...registrationform,
                            username: e.target.value,
                          })
                        }
                        placeholder="Username"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                        required
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="password"
                        className="block mb-2 text-sm text-left font-medium text-white dark:text-white"
                      >
                        Wallet Address
                      </label>
                      {isConnected ? (
                        <input
                          value={address}
                          placeholder="Wallet Address"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                        />
                      ) : (
                        <input
                          value=""
                          placeholder="Wallet Address"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                        />
                      )}
                    </div>

                    <div className="text-blue-200">
                      <label className="flex gap-1 items-center">
                        <input
                          type="checkbox"
                          disabled={!checkTerms}
                          className="block text-sm text-left font-medium"
                          checked={checkTerms}
                        />

                        <label
                          onClick={openTermsModal}
                          className="block my-2 cursor-pointer text-sm text-left font-medium"
                        >
                          Accept Terms & Conditions*
                        </label>
                      </label>
                    </div>

                    <button
                      className={`w-full mt-4 text-white  focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center ${
                        registrationform.username &&
                        address &&
                        phoneno &&
                        checkTerms &&
                        registrationform.username
                          ? "bg-blue-800"
                          : "bg-blue-300"
                      } dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800`}
                      disabled={
                        !registrationform.username ||
                        !address ||
                        !checkTerms ||
                        !phoneno ||
                        !registrationform.email
                      }
                      onClick={() => {
                        submitUserDetails();
                        openVerificationModal();
                      }}
                      // data-modal-target="verification-modal"
                      // data-modal-toggle="verification-modal"
                      // data-modal-hide="authentication-modal"
                    >
                      Verify
                    </button>
                    <div className="flex gap-1">
                      <h1 className="text-white">Already Registered?</h1>
                      <h1
                        className="text-white hover:cursor-pointer"
                        // data-modal-target="option-modal"
                        // data-modal-toggle="option-modal"
                        // data-modal-hide="authentication-modal"
                        onClick={() => openSigninModal()}
                      >
                        Sign In
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
              <button
                onClick={props.modalCryptoClose}
                type="button"
                className="mx-4 my-2 w-[90%] text-center rounded-lg bg-white px-5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 "
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      {showTermsModal ? (
        <TermsnConditions
          modalTermsClose={() => {
            openTermsModal();
          }}
          button = "Accept Terms & Conditions"
          check={checkTermsHandel}
        />
      ) : (
        ""
      )}

      {showSigninModal ? (
        <Signinoption
          modalSigninClose={() => {
            props.modalCryptoClose();
            openSigninModal();
          }}
        />
      ) : (
        ""
      )}

      {showVerificationModal ? (
        <Verifyregistration
          modalVerificationClose={() => {
            props.modalCryptoClose();
            openVerificationModal();
          }}
        />
      ) : (
        ""
      )}

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </>
  );
};

export default Registration;
